import script from "./RestaurantPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RestaurantPage.vue?vue&type=script&setup=true&lang=js"

import "./RestaurantPage.vue?vue&type=style&index=0&id=080b09ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080b09ae"]])

export default __exports__